import React from 'react'
import PropTypes from 'prop-types'
import QRCode from 'qrcode.react'

// @material-ui
import { Box, Card, CardContent } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'
import { CropFree } from '@material-ui/icons'

// core
import { withLang } from '_core/hocs/withLang'
import { Menu } from '_core/components/Menu'
import { State } from '_core/components/State'
import { ClipboardInput } from '_core/components/ClipboardInput'
import CardTitle from '_core/components/CardTitle/CardTitle'

// style
import { referralLinkStyle } from './referralLinkStyle'

const RawReferralLinkView = props => {
  const { classes, visitorLinks, getLangString: l } = props

  const renderLinks = list =>
    list.map(item => (
      <Box
        key={item.id}
        className={classes.box}
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <ClipboardInput
          value={item.link}
          label={item.title}
          className={classes.input}
          helperText=""
        />

        <Menu
          tooltip={l('r.ili.otskaniruyte')}
          content={
            <QRCode
              value={item.link}
              level="L"
              size={175}
              className={classes.code}
            />
          }
          buttonBody={<CropFree />}
          buttonProps={{
            size: 'small',
            className: classes.button,
          }}
          paperProps={{
            className: classes.popup,
          }}
          popoverProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
          }}
        />
      </Box>
    ))

  return (
    <State
      waitProps={{ visitorLinks }}
      render={({ visitorLinks }) => {
        if (!Array.isArray(visitorLinks) || visitorLinks.length === 0) {
          return null
        }

        return (
          <div className={classes.root}>
            <CardTitle icon="link" title={l('r.referalnaya.ssylka')} />

            <Card className={classes.card}>
              <CardContent>{renderLinks(visitorLinks)}</CardContent>
            </Card>
          </div>
        )
      }}
    />
  )
}

RawReferralLinkView.defaultProps = {}

RawReferralLinkView.propTypes = {
  // self props
  visitorLinks: PropTypes.arrayOf(PropTypes.object),

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ReferralLinkView = withLang(
  withStyles(referralLinkStyle)(RawReferralLinkView)
)
